import { render, staticRenderFns } from "./close_add.vue?vue&type=template&id=cdc46e8a&"
import script from "./close_add.vue?vue&type=script&lang=ts&"
export * from "./close_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports